import CityPageTemplate from "../city-template/CityPageTemplate";
import { middletownDeConfig } from "./data";

export default function MiddletownDePage() {
  return <CityPageTemplate config={middletownDeConfig} />;
}